import componentsCss from "@talentech/components/build/index.css?inline";

const DATEPICKER_SELECTOR = /flatpickr|input-decorator/;

const isDatepickerRule = (rule: CSSRule) =>
  (rule instanceof CSSStyleRule &&
    DATEPICKER_SELECTOR.test(rule.selectorText)) ||
  (rule instanceof CSSKeyframesRule && rule.name.startsWith("fp"));

export const addDatepickerStyles = () => {
  const sheet = new CSSStyleSheet();
  sheet.replaceSync(componentsCss);
  const style = document.createElement("style");
  style.textContent = Array.from(sheet.cssRules)
    .filter(isDatepickerRule)
    .map((rule) => rule.cssText)
    .join("\n");
  document.head.appendChild(style);
};
